export default "__VITE_ASSET__O$JmN5pK__"